





























































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { fromEvent } from 'rxjs';
import ButtonDefault from '@/components/button/default.vue';

@Component({
  components: {
    ButtonDefault,
  },
})
export default class LayoutHeader extends Vue {

  /**
   * PCヘッダー要素
   */
  private headerPc!: HTMLElement;

  /**
   * SPヘッダー要素
   */
  private headerSp!: HTMLElement;

  /**
   * ヘッダースクロール要素
   */
  private scroll!: HTMLElement;

  /**
   * スクロール中か
   */
  private isScroll: boolean = false;

  /**
   * スクロールポジション
   */
  private position: number = 200;

  /**
   * mountedフック
   */
  public mounted(): void {
    this.headerPc = this.$refs.headerPc as HTMLElement;
    this.headerSp = this.$refs.headerSp as HTMLElement;
    this.scroll = this.$refs.scroll as HTMLElement;
    fromEvent(window, 'load').subscribe((event: any): void => {
      this.scrollListener();
    });
    fromEvent(window, 'scroll').subscribe((event: any): void => {
      this.scrollListener();
      this.headerScroll();
    });
    this.scrollListener();
  }

  /**
   * メニュー開閉
   */
  public toggleMenu(event: any): void {
    event.stopPropagation();
    this.headerSp.classList.toggle('is-active');
    this.headerPc.classList.toggle('is-active');
    this.$store.commit('setMenu', this.headerSp.classList.contains('is-active'));
    this.scrollListener();
  }

  /**
   * メニュー開閉
   */
  public hideMenu(): void {
    this.headerSp.classList.remove('is-active');
    this.headerPc.classList.remove('is-active');
    this.$store.commit('setMenu', false);
  }

  /**
   * スクロールイベント
   */
  private scrollListener(): void {
    const pageStart: number = document.documentElement!.scrollTop ?
      document.documentElement!.scrollTop : document.body!.scrollTop;

    if (pageStart > this.position) {
      this.headerPc.classList.add('is-scroll');
    } else {
      this.headerPc.classList.remove('is-scroll');
    }
  }

  /**
   * scroll function
   */
  private headerScroll(): void {
    const pos: any = this.scroll.getBoundingClientRect().top + window.pageYOffset;
    const pointPos: any = window.screenY;
    const distance = pos - pointPos;

    // distanceがマイナスなら画面内
    if (this.headerSp.classList.contains('is-active')) {
      if (distance <= 20) {
        this.scroll.classList.remove('is-scroll');
      } else if (distance > 21) {
        this.scroll.classList.add('is-scroll');
      }
    } else {
      this.scroll.classList.remove('is-scroll');
    }
  }

}
